import * as React from "react";
import './WPTable.css'
import {WPBasicColumn} from "shared/controls/WPTable/Columns/WPBasicColumn";
import {WPTableSortDirectionEnum, WPTH} from "shared/controls/WPTable/WPTH";
import {SortSnippets} from "shared/utilities/Snipets/SortSnippets";
import {Children, CSSProperties, ReactNode} from "react";
import {WPPagination} from "shared/controls/WPTable/WPPagination";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSpinner} from "@fortawesome/free-solid-svg-icons/faSpinner";
import {library} from "@fortawesome/fontawesome-svg-core";
import {WPTR} from "shared/controls/WPTable/WPTR";
library.add(faSpinner);

export class WPTable extends React.Component<WordpressTableProps, WordpressTableState> {
    static defaultProps: Partial<WordpressTableProps> = {
        ActionClicked:null,
        EmptyContent:null,
        TotalNumberOfRows:0,
        PageIndex:0,
        PageSize:0,
        IsBusy:false,
        BulkActions:[],
        StickyOffset:0,
        SortingChanged:null,
        FillScreen:false,
        StickyLeft:null
    };
    public Columns:WPBasicColumn[];
    public Table:HTMLTableElement;
    constructor(props: WordpressTableProps) {
        super(props);
        this.state= {
            SortDirection:WPTableSortDirectionEnum.none,
            SortColumnName:''
        };
        this.CreateColumnList(props);
        this.RenderTable=this.RenderTable.bind(this);

    }

    public RenderTable(table:any)
    {
        this.Table=table as any;
    }


    componentDidMount(): void {
        if(this.props.FillScreen)
            this.RecalculateTableSize();
    }

    componentWillReceiveProps(nextProps: Readonly<WordpressTableProps>, nextContext: any): void {
        let oldChildrens =Children.toArray(this.props.children);
        let newChildrens =Children.toArray((nextProps as any).children);

        if(oldChildrens.length!=newChildrens.length)
        {
            this.CreateColumnList( (nextProps as any));
            return;
        }

        for(let i=0;i<oldChildrens.length;i++)
        {
            if((oldChildrens[i] as any).key!=newChildrens[i].key) {
                this.CreateColumnList((nextProps as any));
                return;
            }

        }



    }

    public render() {
        let data=this.props.Data;

        return (
            <div>
                <div className="tablenav top">
                    {this.CreatePagination()}
                </div>
                <div style={{position:'relative',...this.props.TableContainerStyles}}>
                    <table className={'rnTable wp-list-table widefat fixed striped entries'} style={{border:"none"}} ref={this.RenderTable}>
                        <thead>
                            <tr>
                                {this.Columns.map((x,index)=>
                                    <WPTH Column={x} Data={this.props.Data} CheckedChanged={()=>this.forceUpdate()} StickyLeft={index==0?this.props.StickyLeft:null} StickyOffset={this.props.StickyOffset} Styles={{...x.props.HeaderStyle, width:x.props.Width}}  key={x.props.PropertyName} IsSortable={x.props.IsSortable}
                                          SortingChanged={e=>this.props.SortingChanged&&this.props.SortingChanged(e,x.props.PropertyName)} SortDirection={this.props.SortPropertyName==x.props.PropertyName?this.props.SortDirection:WPTableSortDirectionEnum.none} IsNumeric={x.props.IsNumeric} >

                                        {index==0&&!x.props.HasCheckBox&&this.MaybeAddCheckBox()}
                                        {x.props.Title}
                                    </WPTH>
                                )}
                            </tr>
                        </thead>
                        <tbody>
                            {this.props.Data.length==0&&this.props.EmptyContent!=null&&
                                <tr>
                                    <td colSpan={this.Columns.length}>{this.props.EmptyContent}</td>
                                </tr>
                            }
                        {this.props.Data.length>0&&this.props.Data.map((row,index)=>
                            <WPTR key={index} WPTable={this} Data={row} Index={index}/>

                        )}

                        </tbody>
                    </table>
                    {this.props.IsBusy&&
                        <div style={{position: "absolute", top: 0, left: 0, width: this.Table!=null?this.Table.getBoundingClientRect().width:'100%', height: '100%',zIndex:10,backgroundColor:'rgba(0,0,0,.5)'}}>
                            <div style={{color: 'white',display:'inline-block',padding:10,position:'sticky',left:this.props.StickyLeft,top:this.props.StickyOffset}}>
                                <h1 style={{color:"white",display:'inline'}}>
                                    <FontAwesomeIcon icon={"spinner"} spin={true}/> Loading...
                                </h1>
                            </div>

                        </div>
                    }
                </div>
                <div className="tablenav top">
                    {this.CreatePagination()}
                </div>
            </div>
        )
    }

    private MaybeAddCheckBox() {

        if(this.props.BulkActions==null||this.props.BulkActions.length==0)
            return null;

        let isSelected=!this.props.Data.some(x=>x[this.props.BulkProperty]==false);


        return <input style={{margin:0}} type={'checkbox'} checked={isSelected} onChange={x=>{
            this.props.Data.forEach(y=>y[this.props.BulkProperty]=x.target.checked);
            this.forceUpdate()}
        }/>

    }

    private ShortChanged(PropertyName: string, e: WPTableSortDirectionEnum) {

        this.setState({
            SortColumnName:PropertyName,
            SortDirection:e
        })
    }

    private CreatePagination() {
        return <WPPagination BulkActions={this.props.BulkActions} PageIndex={this.props.PageIndex} RowsCount={this.props.TotalNumberOfRows} Size={this.props.PageSize} PageChanged={this.props.PageChanged} AvailablePageSizes={this.props.AvailableSizes} PageSizeChanged={x=>this.props.PageSizeChanged(x)}/>
    }

    private CreateColumnList(props:any) {
        let array=Children.toArray(props.children) as any;
        this.Columns=[];
        for(let item of array)
        {
            this.Columns.push(new item.type(item.props));
        }

    }

    private RecalculateTableSize() {

    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface WordpressTableProps {
    Data:any[];
    ActionClicked:(actionId:string,row:any,e?:React.MouseEvent)=>void;
    RowClicked?:(row:any,e?:React.MouseEvent)=>void;
    EmptyContent?:ReactNode;
    TotalNumberOfRows:number;
    PageSize:number;
    PageIndex:number;
    PageChanged:(pageIndex:number)=>void;
    IsBusy:boolean;
    BulkActions:BulkActions[];
    StickyOffset:number;
    StickyLeft:number;
    SortingChanged?:(direction:WPTableSortDirectionEnum,PropertyName:string)=>void;
    SortPropertyName:string;
    SortDirection:WPTableSortDirectionEnum;
    TableContainerStyles:CSSProperties;
    FillScreen:boolean;
    AvailableSizes:{Label:string,Size:number}[];
    PageSizeChanged:(pageSize)=>void;
    BulkProperty:string;

}

interface WordpressTableState {

}


export interface BulkActions {
    Title:string;
    CallBack:()=>boolean|Promise<boolean>;
}

//#endregion "My Region"